import {
  InmateDetailsContainer,
  StyledActionControlContainer,
  StyledDarkSectionTitle,
  StyledGridCol,
  StyledGridRow,
} from "@/common/styles";
import BookingsDetails from "@/components/BookingsDetails";
import { StyledBookingsContainer, StyledBookingsContent } from "./styles";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { ActionHeader } from "../CreateBooking/styles";
import Button from "@/common/elements/Button";
import { useDispatch, useSelector } from "react-redux";
import { Flex, Form, Input, Spin, message, Tooltip } from "antd";
import {
  setBookings,
  setBookingsFieldsEnabled,
  setBookingsNull,
  setDeleteAPIEmpty,
  setIrisEnrolleId,
  setIrisSearchId,
  setIsScheduledBooking,
  setLastBookingsFromAPI,
  setShowBookings,
} from "@/slices/bookingsSlice";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import {
  getDayjsObject,
  getLatestBookingsUtil,
  hasCheckSecurity,
  isNonEmptyVariable,
  toQueryString,
  deepReplaceEmptyWithNull,
  getRefListNameByID,
} from "@/util/common_function";
import notificationService from "@/util/notificationService";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import _ from "lodash";
import useDialog from "@/hooks/useDialog";
import {
  mandatoryFields,
  MODULES_LIST,
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import { getOptionsFromRefList } from "@/util/common_function";
import axios from "axios";
import DropdownButton from "@/common/elements/DropdownButton";
import { ROUTES_PATH } from "@/routes";
import ReportList from "./ReportList";
import BookingsFilter from "./filter";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import NoAccess from "@/components/BookingsDetails/NoAccess";
import HouseAndTracksForm from "@/components/HouseandTracking/HouseAndTrackingForm";
import { REF_LIST_CODE } from "@/util/refList";
import SearchIris from "@/components/InmateDetails/SearchIris";
import { setFullSearch } from "@/slices/fullSearchSlice";
import { ReportModalContext } from "@/contexts/ReportModalContext";
import { useContext } from "react";

const { Search } = Input;

const BookingsPage = ({
  isBQ = false,
  nextBookingStep = null,
  bqCompleteSaveAction,
  fromBookingStep = false,
  fromFolderDetails = false,
}) => {
  const { headerHeight } = useOutletContext();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const dispatch = useDispatch();
  const { showDialog } = useDialog();
  const {
    bookings,
    LastBookingsFromAPI,
    deleteAPis,
    isScheduledBooking,
    showBookings,
    irisSearchId,
    irisEnrolleId,
  } = useSelector((state) => state?.bookings);
  const { isLoading: userDetailLoading } = useSelector(
    (state) => state?.userDetail,
  );

  const nextBtnRef = useRef();
  const tabChangeRef = useRef();
  const cancelTokenSourceRef = useRef(null);

  const [saveVisible, setSaveVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTxt, setSearchTxt] = useState("");
  const [user, setUser] = useState(null);
  const [reportListLoading, setReportListLoading] = useState(false);
  const [reportListData, setReportListData] = useState([]);
  const [filteredReportListData, setFilteredReportListData] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [reportListTotal, setReportListTotal] = useState();
  const [isFiltered, setIsFiltered] = useState(false);
  const [bookingSearchPayload, setBookingSearchPayload] = useState([
    { filterKey: "searchType", value: "Starts With" }, // { filterKey: "custodyStatus", value: "In Custody" },
  ]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 100,
  });
  const [tablePagination, setTablePagination] = useState({
    pageIndex: 0,
    pageSize: 100,
  });
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate();
  const [isShowTracking, setisShowTracking] = useState(false);
  const houseFormRef = useRef();
  const [isLoadingHT, setisLoadingHT] = useState(false);
  const fullSearch = useSelector((state) => state.fullSearch);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [currentTabKey, setCurrentTabKey] = useState(null);

  const allFormRef = {
    personalFormRef: useRef(),
    personalFormAliasesRef: useRef(),
    personalFormPlaceOfBirthRef: useRef(),
    personalFormDistinguishingRef: useRef(),
    arrestbookFormRef: useRef(),
    bookingInfoFormRef: useRef(),
    scheduledBookingRef: useRef(),
    bookingChargeRef: useRef(),
    inmateInfoRef: useRef(),
    scheduledEventRef: useRef(),
    boookingsRelease: useRef(),
    bookingsCommentsRef: useRef(),
    folderFlagsRef: useRef(),
    classificationDetailsRef: useRef(),
    bookingsMovementRulesRef: useRef(),
    houseFormRef: useRef(),
    associatesDetailsRef: useRef(),
    bookingHoldsRef: useRef(),
    docsRef: useRef(),
    signaturesRef: useRef(),
    victimNotificationDetailsRef: useRef(),
    billingDetailsRef: useRef(),
    visitorLogDetailsRef: useRef(),
    jailIncidentsDetailsRef: useRef(),
    bookingQueueDetailsRef: useRef(),
    releaseQueueDetailsRef: useRef(),
    medicalRef: useRef(),
    inmateMedicationsDetailsRef: useRef(),
    medicalAuthorizationsDetailsRef: useRef(),
    appointmentLogDetailsRef: useRef(),
    propertyRef: useRef(),
    propertyListRef: useRef(),
    OfficerReportsDetailsRef: useRef(),
    bookingAdministrativeInformationRef: useRef(),
  };

  const DropdownButtonItem = [
    {
      label: "Scheduled Booking",
      key: "scheduledBooking",
    },
  ];

  // const [results, setResults] = useState([]);
  const [isFindModalVisible, setIsFindModalVisible] = useState(false);
  // const [isReportModalVisible, setIsReportModalVisible] = useState(false);
  const { setIsReportModalVisible, setResults } =
    useContext(ReportModalContext);

  useEffect(() => {
    if (isScheduledBooking && bookings === null) {
      dispatch(setIsScheduledBooking(false));
    }
    const loginUser = JSON.parse(localStorage.getItem("userDetails"));
    if (isNonEmptyVariable(loginUser)) {
      setUser(loginUser);
    }
    if (!isBQ) {
      const fj = sessionStorage.getItem("from-jacket");
      if (
        !isNonEmptyVariable(fj) ||
        (isNonEmptyVariable(fj) && fj == "false")
      ) {
        console.log("LastBookingsFromAPI", LastBookingsFromAPI);

        dispatch(setBookings(LastBookingsFromAPI));
        // getLatestBookings();
      }

      if (isNonEmptyVariable(fj) && fj == "true") {
        setSaveVisible(true);
        dispatch(setShowBookings(true));
      } else {
        setSaveVisible(false);
      }
    }
    return () => {
      dispatch(setFullSearch(false));
      if (!!!fromFolderDetails) dispatch(setShowBookings(false));
      // dispatch(setBookingsNull());
      // dispatch(setBookingsFieldsEnabled(false));
    };
  }, []);

  useEffect(() => {
    console.log("ShowBookings");
    setCurrentTabKey("personal-information");
  }, [showBookings]);

  useEffect(() => {
    if (!isBQ && !showFilter) {
      getReportListData();
    }
  }, [tablePagination]);

  useEffect(() => {
    if (isBQ) {
      dispatch(setShowBookings(true));
      modifyBookingsAction();
      if (isNonEmptyVariable(nextBookingStep)) {
        if (nextBookingStep?.key === "medical-questionnaires") {
          setTimeout(() => {
            tabChangeRef.current?.setSelectedGroup("inmate-medical");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange(nextBookingStep?.key);
            }, 600);
          }, 500);
        } else {
          setTimeout(() => {
            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange(nextBookingStep?.key);
            }, 600);
          }, 500);
        }

        const bookingNumber = isNonEmptyVariable(
          nextBookingStep?.value?.booking,
        )
          ? nextBookingStep?.value?.booking
          : "";
        if (isNonEmptyVariable(bookingNumber)) {
          onSearch(bookingNumber);
        }
      }
    }
  }, [isBQ]);

  const location = useLocation();
  const { module } = location.state || {};

  useEffect(() => {
    // console.log("bookings", bookings);
    const scheduledBooking =
      bookings?.bookingId && bookings?.arrestReports?.[0]?.scheduledBooking;
    if (
      scheduledBooking &&
      bookings?.arrestReports?.[0]?.scheduledBookingCleared !== true
    ) {
      dispatch(setIsScheduledBooking(true));
    } else if (
      bookings?.bookingId &&
      !(
        bookings?.arrestReports?.[0]?.scheduledBooking === true &&
        bookings?.arrestReports?.[0]?.scheduledBookingCleared === true
      )
    ) {
      dispatch(setIsScheduledBooking(false));
    }
  }, [bookings]);

  useEffect(() => {
    if (!location?.state?.refresh) return;

    setBookingSearchPayload([
      { filterKey: "searchType", value: "Starts With" },
    ]);
    setIsFiltered(false);

    setReportListData([]);
    setReportListTotal(0);

    setPagination({
      pageIndex: 0,
      pageSize: 100,
    });

    dispatch(setFullSearch(false));
    dispatch(setShowBookings(false));
    setTablePagination({
      pageIndex: 0,
      pageSize: 100,
    });
  }, [location.state?.refresh]);

  const onNextClickTrigger = () => {
    nextBtnRef?.current?.onNextClick();
  };

  const modifyBookingsAction = () => {
    setSaveVisible(true);
    dispatch(setBookingsFieldsEnabled(true));
  };

  const newBookingsAction = (e, scheduledBooking = false) => {
    if (cancelTokenSourceRef.current) {
      cancelTokenSourceRef.current.cancel("new booking.");
    }
    sessionStorage.setItem("jacket-before", MODULES_LIST?.BOOKINGS);
    dispatch(setIsScheduledBooking(scheduledBooking));
    setIsLoading(() => false);
    navigate(ROUTES_PATH?.JACKET_SEARCH);
    // if (module !== "arrest-report") {
    //   showDialog("info", {
    //     title: "Warning",
    //     content: `You can only create new records when you are in the Arrest Report submodule.`,
    //     confirmButtonText: "Ok",
    //   });
    //   return;
    // }
    // setSaveVisible(true);
    dispatch(setBookingsNull());
  };

  const cancelBookingsAction = () => {
    setSaveVisible(false);
    setSearchTxt("");
    setIsLoading(() => false);
    dispatch(setBookings(LastBookingsFromAPI));
    dispatch(setBookingsFieldsEnabled(false));
    dispatch(setIsScheduledBooking(false));
    dispatch(setIrisSearchId(0));
    dispatch(setIrisEnrolleId(0));
    dispatch(setFullSearch(false));
  };

  const getLatestBookings = () => {
    // Create a new cancel token source for the current request
    cancelTokenSourceRef.current = axios.CancelToken.source();

    setIsLoading(() => true);
    let url = API_ENDPOINTS.latestStaffBooking;
    if (user?.staffId === 1) {
      url = API_ENDPOINTS.latestBooking;
    }
    api
      .get(url, { cancelToken: cancelTokenSourceRef.current.token })
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(setBookings(response?.data));
          dispatch(setLastBookingsFromAPI(response?.data));
          setIsLoading(() => false);
        }
      })
      .catch((error) => {
        setIsLoading(() => false);
        if (axios.isCancel(error)) {
          console.error("Request canceled:", error.message);
        } else {
          console.error(
            "Request failed:",
            error.response ? error.response.data : error.message,
          );
        }
      });
  };

  const preRebook = () => {
    let validations = [Promise.resolve(true)];
    validations = [
      allFormRef?.personalFormRef?.current?.validateFields(),
      allFormRef?.personalFormAliasesRef?.current?.validateFields(),
      allFormRef?.personalFormPlaceOfBirthRef?.current?.validateFields(),
    ];
    Promise.all(validations)
      .then(() => {
        if (
          !isNonEmptyVariable(bookings?.arrestReports?.[0]?.agency) ||
          !isNonEmptyVariable(bookings?.arrestReports?.[0]?.arrestCity)
        ) {
          notificationService.error(
            "Validation Error",
            `Please fill arrest information mandatory fields`,
          );
          tabChangeRef.current?.setSelectedGroup("arrest-report");
          setTimeout(() => {
            tabChangeRef.current?.onTabChange("arrest-information");
            allFormRef?.arrestbookFormRef?.current?.validateFields();
          }, 0);

          return;
        }
        setisShowTracking(() => true);
      })
      .catch((err) => {
        let tabToChange = "personal-information";
        let requiredField = err?.errorFields[0]?.name[0];

        if (requiredField) {
          tabToChange =
            Object.keys(mandatoryFields).find((tab) =>
              mandatoryFields[tab].includes(requiredField),
            ) || "personal-information";
        }

        notificationService.error(
          "Validation Error",
          `Fill all mandatory fields in ${tabToChange
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")}`,
        );

        setTimeout(() => {
          tabChangeRef.current?.onTabChange(tabToChange);
          // Move focus to the first error element
          setTimeout(() => {
            const firstErrorField = document.querySelector(`#${requiredField}`);

            firstErrorField?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            firstErrorField?.focus();
          }, 300);
        }, 0);
      });
  };

  const handleSave = () => {
    houseFormRef?.current?.validateFields().then((values) => {
      const ht = {
        ...values,
        actualDate: isNonEmptyVariable(values?.actualDateTime)
          ? dayjs(values?.actualDateTime)?.format("MM/DD/YYYY")
          : null,
        actualTime: isNonEmptyVariable(values?.actualDateTime)
          ? dayjs(values?.actualDateTime)?.format("HH:mm")
          : null,
        expectedBackDate: isNonEmptyVariable(values?.xpectedBackDateTime)
          ? dayjs(values?.expectedBackDateTime)?.format("MM/DD/YYYY")
          : null,
        expectedBackTime: isNonEmptyVariable(values?.expectedBackDateTime)
          ? dayjs(values?.expectedBackDateTime)?.format("HH:mm")
          : null,
      };

      const newInvolvement = {
        invCreatedBy: user?.staffId,
        invObjType: 3,
        invObjId: bookings.bookingId,
        invCreatedDate: dayjs().format("MM/DD/YYYY HH:mm:ss"),
        linkedObjectType: "Folders",
        relatedObjectType: "Bookings",
        flagTypeID: REF_LIST_CODE.FLAG_TYPE.INJAIL,
      };

      const b = _.cloneDeep(bookings);
      b?.inmateTracking?.push(ht);
      b?.cdInvolvements?.push(newInvolvement);

      setisLoadingHT(() => true);

      preSaveBookingAction(null, "rebook", b);
    });
  };

  const fullSearchAction = async () => {
    console.log("Full Search Called Successfully");
    console.log(bookings);

    const fullSearchPayload = deepReplaceEmptyWithNull(bookings);
    try {
      setIsLoading(() => true);
      const response = await api.post(
        API_ENDPOINTS.bookingsFullSearch + "?size=500&direction=asc",
        fullSearchPayload,
      );

      console.log("Response");
      console.log(response);
      const data = response?.data;
      console.log("Data");
      console.log(data);
      // console.log(isReportModalVisible);
      setIsLoading(() => false);
      if (!data?.rows?.length) {
        notificationService.error(
          "No records found for the given search criteria",
        );
      } else {
        setResults(data?.rows);
        setIsReportModalVisible(true);
        setIsFindModalVisible(false);
      }
    } catch (error) {
      console.error("Full Search Error:", error);
    }
  };

  const preSaveBookingAction = (e, action = "save", payload = null) => {
    // Handle the rebook flow for scheduled booking
    if (action === "rebook" && !payload?.inmateTracking?.length) {
      notificationService.error(
        "You must have complete move status in house & track",
      );
      tabChangeRef.current?.setSelectedGroup("arrest-report");
      setTimeout(() => {
        tabChangeRef.current?.onTabChange("housing-tracking");
      }, 0);

      dispatch(
        setBookings({
          arrestReports: [
            {
              ...bookings?.arrestReports?.[0],
              scheduledBookingCleared: true,
              scheduledBookingClearanceReasonId: 54600006,
            },
          ],
        }),
      );
      dispatch(setIsScheduledBooking(false));
    }
    let validations = [Promise.resolve(true)];
    if (
      (isScheduledBooking || bookings?.arrestReports?.[0]?.scheduledBooking) &&
      action === "save" &&
      bookings?.arrestReports?.[0]?.scheduledBookingCleared !== true
    ) {
      validations = [
        allFormRef?.scheduledBookingRef?.current?.validateFields(),
      ];
    } else if (
      (!isBQ &&
        (!isScheduledBooking ||
          bookings?.arrestReports?.[0]?.scheduledBookingCleared === true)) ||
      action === "rebook"
    ) {
      validations = [
        allFormRef?.personalFormRef?.current?.validateFields(),
        allFormRef?.personalFormAliasesRef?.current?.validateFields(),
        allFormRef?.personalFormPlaceOfBirthRef?.current?.validateFields(),
        // allFormRef?.personalFormDistinguishingRef?.current?.validateFields(),
        allFormRef?.arrestbookFormRef?.current?.validateFields(),
        // allFormRef?.inmateInfoRef?.current?.validateFields(),
        // allFormRef?.propertyRef?.current?.validateFields(),
      ];
    }

    if (bookings?.arrestReports?.[0]?.scheduledBookingCleared === true) {
      if (
        bookings?.arrestReports?.[0]?.scheduledBookingAgency?.toLowerCase() ===
        "jail"
      ) {
        if (
          bookings?.arrestReports?.[0]?.scheduledBookingClearanceReasonId !==
          54600006
        ) {
          let tabToChange = Object.keys(mandatoryFields).find((tab) =>
            mandatoryFields[tab].includes("scheduledBookingClearanceReasonId"),
          );
          setTimeout(() => {
            tabChangeRef.current?.onTabChange(tabToChange);
            const firstErrorField = document.querySelector(`#clearanceReason`);

            firstErrorField?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            firstErrorField?.focus();
          }, 0);

          showDialog("info", {
            title: "Warning",
            content: `Invalid clearance reason. If the inmate is in custody, the Scheduled Booking Clearance Reason should be 'Incarcerated'`,
            confirmButtonText: "Ok",
          });
          return;
        }
      }
    }

    if (action === "rebook") {
      const currentDateTime = dayjs().format("MM/DD/YYYY HH:mm");
      payload = {
        ...payload,
        isNeedToSubmitGenericInterface: true,
        arrestReports: [
          {
            ...payload?.arrestReports?.[0],
            incarcerationDate: currentDateTime.split(" ")[0],
            incarcerationTime: currentDateTime.split(" ")[1],
            releaseDate: null,
            releaseTime: null,
            releaseReasonId: null,
            releaseOfficerStaffId: null,
          },
        ],
      };
    }

    Promise.all(validations)
      .then(() => {
        if (!isScheduledBooking && !isBQ)
          if (
            !isNonEmptyVariable(bookings?.arrestReports?.[0]?.agency) ||
            !isNonEmptyVariable(bookings?.arrestReports?.[0]?.arrestCity)
          ) {
            notificationService.error(
              "Validation Error",
              `Please fill arrest information mandatory fields`,
            );
            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange("arrest-information");
              allFormRef?.arrestbookFormRef?.current?.validateFields();
            }, 0);

            return;
          }

        if (!bookings?.charges?.length && !isScheduledBooking && !isBQ) {
          notificationService.error("Validation Error", `Please add Charges`);
          tabChangeRef.current?.setSelectedGroup("arrest-report");
          setTimeout(() => {
            tabChangeRef.current?.onTabChange("charges");
          }, 0);
          return;
        }

        if (!isScheduledBooking && !bookings?.inmateTracking?.length && !isBQ) {
          notificationService.error(
            "You must have complete move status in house & track",
          );
          tabChangeRef.current?.setSelectedGroup("arrest-report");
          setTimeout(() => {
            tabChangeRef.current?.onTabChange("housing-tracking");
          }, 0);
          return;
        }

        if (
          !isScheduledBooking &&
          bookings?.inmateTracking?.length > 0 &&
          !isBQ
        ) {
          const hasLoanOrJailCompleted = bookings?.inmateTracking?.some(
            (item) =>
              (item?.inmateLocation?.toLowerCase() === "loan" ||
                item?.inmateLocation?.toLowerCase() === "in jail") &&
              item?.movementStatus?.toLowerCase() === "complete",
          );
          const haspermhouseOrtransportCompleted =
            bookings?.inmateTracking?.some(
              (item) =>
                (item?.inmateLocation?.toLowerCase() ===
                  "perm housing change" ||
                  item?.inmateLocation?.toLowerCase() === "transport") &&
                item?.movementStatus?.toLowerCase() === "complete",
            );
          if (haspermhouseOrtransportCompleted && !hasLoanOrJailCompleted) {
            notificationService.error(
              "You must save the Booking record at least once before you can Transport the inmate",
            );
            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange("housing-tracking");
            }, 0);
            return;
          }
          if (!hasLoanOrJailCompleted) {
            notificationService.error(
              "You must have atleast one complete move status in house & track",
            );
            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange("housing-tracking");
            }, 0);
            return;
          }
        }
        // Yoges - Commented this code because when creating a new bookings then charges also mandatory
        // if (isNonEmptyVariable(bookings?.bookingNumber)) {
        //   if (!bookings?.charges?.length && !isScheduledBooking && !isBQ) {
        //     notificationService.error("Validation Error", `Please add Charges`);
        //     tabChangeRef.current?.setSelectedGroup("arrest-report");
        //     setTimeout(() => {
        //       tabChangeRef.current?.onTabChange("charges");
        //     }, 0);

        //     return;
        //   }
        // }
        if (isNonEmptyVariable(payload)) {
          saveBookingsAction(action, payload);
        } else {
          const data = _.cloneDeep(bookings);
          saveBookingsAction(action, data);
        }
      })
      .catch((err) => {
        let tabToChange = "personal-information";
        let requiredField = err?.errorFields[0]?.name[0];

        if (requiredField) {
          tabToChange =
            Object.keys(mandatoryFields).find((tab) =>
              mandatoryFields[tab].includes(requiredField),
            ) || "personal-information";
        }

        notificationService.error(
          "Validation Error",
          `Fill all mandatory fields in ${tabToChange
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")}`,
        );

        if (tabToChange === "property-taken-inmate") {
          tabChangeRef.current?.setSelectedGroup("inmate-property");
        } else {
          tabChangeRef.current?.setSelectedGroup("arrest-report");
        }

        setTimeout(() => {
          tabChangeRef.current?.onTabChange(tabToChange);
          // Move focus to the first error element
          setTimeout(() => {
            const firstErrorField = document.querySelector(`#${requiredField}`);

            firstErrorField?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            firstErrorField?.focus();
          }, 300);
        }, 0);
      });
  };

  function cleanObject(obj) {
    if (Array.isArray(obj)) {
      // If it's an array, recursively clean each item and filter out empty values
      return obj
        .map(cleanObject) // Recursively clean each element
        .filter(
          (value) =>
            value !== undefined &&
            value !== null &&
            value !== "" &&
            (Array.isArray(value) ? value.length > 0 : true) &&
            (typeof value === "object" ? Object.keys(value).length > 0 : true),
        );
    } else if (typeof obj === "object" && obj !== null) {
      // If it's an object, recursively clean its properties
      return Object.entries(obj).reduce((acc, [key, value]) => {
        const cleanedValue = cleanObject(value); // Recursively clean the value
        if (
          cleanedValue !== undefined &&
          cleanedValue !== null &&
          cleanedValue !== "" &&
          (typeof cleanedValue === "object"
            ? Object.keys(cleanedValue).length > 0
            : true)
        ) {
          acc[key] = cleanedValue; // Add only non-empty values
        }
        return acc;
      }, {});
    }
    // If it's a primitive value, return it as-is
    return obj;
  }

  const saveBookingsAction = async (action, data) => {
    const payload = data;
    delete payload?.genericInterfaceSubmission;
    delete payload?.visitorLogBooking;

    // // To set controll agency case number, ori id and inmate status id if not set.
    // if (!isNonEmptyVariable(payload?.arrestReports?.[0]?.controllingAgencyCaseNumber) &&
    //   !isNonEmptyVariable(payload?.arrestReports?.[0]?.controllingAgencyOriId) &&
    //   !isNonEmptyVariable(payload?.arrestReports?.[0]?.inmateStatusId)
    // ) {
    //   payload.arrestReports[0].inmateStatusId = "52119001"; // Default to In Custody if not set
    //   const controllingCharge = payload?.charges?.find(
    //     (charge) => charge.controllingCharge
    //   );
    //   if (isNonEmptyVariable(controllingCharge)) {
    //     payload.arrestReports[0].controllingAgencyCaseNumber =
    //       controllingCharge.caseNumber || "";
    //     payload.arrestReports[0].controllingAgencyOriId =
    //       controllingCharge.controllingAgencyORIID || "";
    //   }
    // }

    // ✅ Ensure arrestReports exists and has at least one element
    if (
      !Array.isArray(payload?.arrestReports) ||
      payload.arrestReports.length === 0
    ) {
      payload.arrestReports = [{}]; // initialize safely
    }

    const firstReport = payload.arrestReports[0];

    // ✅ Set controlling agency info and inmate status if missing
    if (
      !isNonEmptyVariable(firstReport?.controllingAgencyCaseNumber) &&
      !isNonEmptyVariable(firstReport?.controllingAgencyOriId) &&
      !isNonEmptyVariable(firstReport?.inmateStatusId)
    ) {
      firstReport.inmateStatusId = "52119001"; // Default to In Custody if not set

      const controllingCharge = payload?.charges?.find(
        (charge) => charge.controllingCharge,
      );

      if (isNonEmptyVariable(controllingCharge)) {
        firstReport.controllingAgencyCaseNumber =
          controllingCharge.caseNumber || "";
        firstReport.controllingAgencyOriId =
          controllingCharge.controllingAgencyORIID || "";
      }
    }

    if (
      !isNonEmptyVariable(
        payload?.arrestReports?.[0]?.classificationEffectiveDate,
      ) &&
      !isNonEmptyVariable(payload?.arrestReports?.[0]?.classificationId)
    ) {
      payload.arrestReports[0].classificationId = 154550003; // Default to Minimum
      payload.arrestReports[0].classificationEffectiveDate =
        dayjs().format("MM/DD/YYYY");
    }

    const preFinalPayload = cleanObject(payload);

    // handle the scheduled booking
    if (isScheduledBooking) {
      const hasScheduledBookingDate =
        payload?.arrestReports?.[0]?.scheduledBooking;
      if (!hasScheduledBookingDate) {
        showDialog("info", {
          title: "Warning",
          content: "Please fill the Scheduled Booking Information",
          confirmButtonText: "Ok",
        });
        tabChangeRef.current?.setSelectedGroup("arrest-report");
        setTimeout(() => {
          tabChangeRef.current?.onTabChange("scheduled-booking-information");
        }, 0);
        return;
      }
    }

    if (
      isNonEmptyVariable(payload?.arrestReports?.[0].incarcerationDate) &&
      isNonEmptyVariable(payload?.arrestReports?.[0].scheduledReleaseDate)
    ) {
      dayjs.extend(isSameOrAfter);
      const incarcerationDate = dayjs(
        payload?.arrestReports?.[0]?.incarcerationDate,
      );
      const scheduledReleaseDate = dayjs(
        payload?.arrestReports?.[0]?.scheduledReleaseDate,
      );
      if (!scheduledReleaseDate?.isSameOrAfter(incarcerationDate)) {
        showDialog("info", {
          title: "Warning",
          content: `The Scheduled Release Date must be on or after the Incarceration Date for the active Detention (${incarcerationDate})`,
          confirmButtonText: "Ok",
        });
        return;
      }
    }

    if (
      preFinalPayload?.inmateProperty?.[0]?.propertyReleased &&
      (!preFinalPayload?.inmateProperty?.[0]?.releasedTo ||
        !preFinalPayload?.inmateProperty?.[0]?.dateReleased ||
        !preFinalPayload?.inmateProperty?.[0]?.releasedByStaffId)
    ) {
      tabChangeRef.current?.setSelectedGroup("inmate-property");
      setTimeout(() => {
        tabChangeRef.current?.onTabChange("property-taken-inmate");
      }, 100);
      setTimeout(() => {
        allFormRef?.propertyRef?.current?.validateFields();
      }, 300);
      return;
    }

    // if (preFinalPayload.inJail === false) {
    //   preFinalPayload.arrestReports[0].releaseDate = null;
    //   preFinalPayload.arrestReports[0].releaseTime = null;
    //   preFinalPayload.arrestReports[0].releaseReasonId = null;
    //   preFinalPayload.arrestReports[0].holdReasonId ??= 154530006;
    //   // preFinalPayload.inmateTracking?.push({
    //   //   inmateTrackingID: null,
    //   //   inmateLocation: "In Jail",
    //   //   movementStatus: "Complete",
    //   // });
    // }

    const agency = user?.staff?.organization?.[0]?.agency;
    // return;
    const finalPayload = {
      bookings: {
        ...preFinalPayload,
        creatorStaffId: userDetails?.staffId,
        inJail: isScheduledBooking
          ? false
          : isNonEmptyVariable(preFinalPayload?.inJail) && action === "save"
            ? preFinalPayload?.inJail
            : true,
        user: userDetails?.username,
        transactionId: irisSearchId || 0,
        jackets: [
          {
            ...((preFinalPayload?.jackets && preFinalPayload.jackets[0]) || {}),
            staffJacket: false,
            orphanFlag: false,
          },
        ],
        arrestReports: [
          {
            ...((preFinalPayload?.arrestReports &&
              preFinalPayload.arrestReports[0]) ||
              {}),
            housingAgency: agency,
            custodialAgency: agency,
            holdReasonId: isNonEmptyVariable(
              preFinalPayload?.arrestReports?.[0]?.holdReasonId,
            )
              ? preFinalPayload?.arrestReports?.[0]?.holdReasonId
              : 154530006,
            scheduledBookingAgency: agency?.toUpperCase(),
            totalDaysInCustody:
              bookings?.detentions?.length &&
              isNonEmptyVariable(
                bookings?.detentions?.[bookings?.detentions?.length - 1]
                  ?.lengthOfStay,
              )
                ? bookings?.detentions?.[bookings?.detentions?.length - 1]
                    ?.lengthOfStay
                : 0,
          },
        ],
        bio: [
          {
            ...((preFinalPayload?.bio && preFinalPayload.bio[0]) || {}),
            enrolleeId:
              preFinalPayload.bio[0]?.enrolleeId || irisEnrolleId || 0,
            bioPhotos:
              preFinalPayload?.bio[0]?.bioPhotos?.map((p) => {
                return {
                  ...p,
                  lineupFlag: true,
                };
              }) || [],
          },
        ],
      },
    };

    const currentDateTime = dayjs().format("MM/DD/YYYY HH:mm");
    finalPayload.bookings.arrestReports[0].incarcerationDate ??=
      currentDateTime.split(" ")[0];
    finalPayload.bookings.arrestReports[0].incarcerationTime ??=
      currentDateTime.split(" ")[1];

    if (
      !isNonEmptyVariable(finalPayload?.bookings?.bookingsQueue) ||
      !finalPayload?.bookings?.bookingsQueue?.length
    ) {
      finalPayload.bookings.bookingsQueue = [
        {
          creatorStaffId: 1,
        },
      ];
    } else {
    }

    if (
      finalPayload?.bookings?.charges?.length &&
      finalPayload?.bookings?.charges?.every((c) => c?.clearedToGo === true)
    ) {
      finalPayload.bookings.readyForRelease = true;
    }

    if (finalPayload?.bookings?.bookingSignature?.length) {
      const bsa = _.cloneDeep(finalPayload?.bookings?.bookingSignature);
      finalPayload.bookings.bookingSignature = bsa?.map((bs) => {
        if (
          !bs?.signature?.[0]?.photos?.[0]?.fullSizePath?.includes("TempPhotos")
        ) {
          delete bs?.signature?.[0]?.photos;
        }
        return bs;
      });
    }

    // Booking_queue
    // INTAKE
    if (
      !finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
        (item) => item.queStepID === REF_LIST_CODE.BQ_STEPS.INTAKE,
      ) ||
      finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
        (item) => item.queStepID === REF_LIST_CODE.BQ_STEPS.BOOKING_COMPLETE,
      )
    ) {
      finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
        ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
          []),
        {
          queStepID: REF_LIST_CODE.BQ_STEPS.INTAKE, // For house & track
          complete: true,
          completionDate: dayjs().format("MM/DD/YYYY"),
          completionTime: dayjs().format("HH:mm"),
          completionStaffID: userDetails?.staffId,
        },
      ];
    }

    if (
      finalPayload?.bookings?.charges?.length &&
      !(
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190012,
        ) ||
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190002,
        )
      )
    ) {
      finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
        ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
          []),
        {
          queStepID: 155190012, // For charges
          complete: true,
          completionDate: dayjs().format("MM/DD/YYYY"),
          completionTime: dayjs().format("HH:mm"),
          completionStaffID: userDetails?.staffId,
        },
      ];
    }

    if (
      finalPayload?.bookings?.medicalQuestionnaires?.length &&
      !(
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190003,
        ) ||
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190002,
        )
      )
    ) {
      finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
        ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
          []),
        {
          queStepID: 155190003, // For medical
          complete: true,
          completionDate: dayjs().format("MM/DD/YYYY"),
          completionTime: dayjs().format("HH:mm"),
          completionStaffID: userDetails?.staffId,
        },
      ];
    }

    if (
      finalPayload?.bookings?.inmateClassificationQuestionnaires?.length &&
      !(
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190005,
        ) ||
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190002,
        )
      )
    ) {
      finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
        ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
          []),
        {
          queStepID: 155190005, // For classifications
          complete: true,
          completionDate: dayjs().format("MM/DD/YYYY"),
          completionTime: dayjs().format("HH:mm"),
          completionStaffID: userDetails?.staffId,
        },
      ];
    }

    if (
      finalPayload?.bookings?.bookingsJacketsJackets?.length &&
      !(
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190014,
        ) ||
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190002,
        )
      )
    ) {
      finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
        ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
          []),
        {
          queStepID: 155190014, // For associates
          complete: true,
          completionDate: dayjs().format("MM/DD/YYYY"),
          completionTime: dayjs().format("HH:mm"),
          completionStaffID: userDetails?.staffId,
        },
      ];
    }

    if (
      finalPayload?.bookings?.bio?.[0]?.bioPhotos?.length &&
      !finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
        (item) => item.queStepID === 155190007,
      )
    ) {
      finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
        ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
          []),
        {
          queStepID: 155190007, // For mugshot
          complete: true,
          completionDate: dayjs().format("MM/DD/YYYY"),
          completionTime: dayjs().format("HH:mm"),
          completionStaffID: userDetails?.staffId,
        },
      ];
    }

    if (
      finalPayload?.bookings?.inmateTracking?.length &&
      !(
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190011,
        ) ||
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190002,
        )
      )
    ) {
      finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
        ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
          []),
        {
          queStepID: 155190011, // For house & track
          complete: true,
          completionDate: dayjs().format("MM/DD/YYYY"),
          completionTime: dayjs().format("HH:mm"),
          completionStaffID: userDetails?.staffId,
        },
      ];
    }

    if (
      finalPayload?.bookings?.cdInvolvements?.length &&
      !finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
        (item) => item.queStepID === 155190015,
      )
    ) {
      finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
        ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
          []),
        {
          queStepID: 155190015, // For jacket flag
          complete: true,
          completionDate: dayjs().format("MM/DD/YYYY"),
          completionTime: dayjs().format("HH:mm"),
          completionStaffID: userDetails?.staffId,
        },
      ];
    }

    if (
      finalPayload?.bookings?.victimNotifications?.length &&
      !finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
        (item) => item.queStepID === 155190016,
      )
    ) {
      finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
        ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
          []),
        {
          queStepID: 155190016, // For Victim notification
          complete: true,
          completionDate: dayjs().format("MM/DD/YYYY"),
          completionTime: dayjs().format("HH:mm"),
          completionStaffID: userDetails?.staffId,
        },
      ];
    }

    if (
      isNonEmptyVariable(
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails,
      ) &&
      finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.length &&
      finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
        (x) => x?.queStepID === 155190013, // Remove From BQ
      )
    ) {
      if (
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (x) => x?.queStepID === 155190007, // MugSHOT
        )
      ) {
        // finalPayload.bookings.bookingsQueue =
        //   finalPayload?.bookings?.bookingsQueue?.map((bq) => {
        //     return {
        //       ...bq,
        //       complete: true,
        //     };
        //   });
      } else {
        showDialog("info", {
          title: "Warning",
          content: "You must have complete mugshot",
          confirmButtonText: "Ok",
        });
        return;
      }
    }

    if (
      finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.length &&
      !finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
        (item) => item.queStepID === 155190002,
      )
    ) {
      const booking = finalPayload?.bookings;
      if (isNonEmptyVariable(booking)) {
        if (
          booking?.charges?.length &&
          booking?.bookingsJacketsJackets?.length
        ) {
          finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
            ...(finalPayload?.bookings?.bookingsQueue?.[0]
              ?.bookingQueueDetails || []),
            {
              queStepID: 155190002, // For Booking complete
              complete: true,
              completionDate: dayjs().format("MM/DD/YYYY"),
              completionTime: dayjs().format("HH:mm"),
              completionStaffID: userDetails?.staffId,
            },
          ];
        }
      }
    }

    finalPayload.bookings.bookingsQueue = [
      {
        bookingQueueDetails:
          finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails,
      },
    ];

    delete finalPayload?.bookings?.bookingQueueDetails;

    if (
      (!finalPayload?.bookings?.charges?.length ||
        finalPayload?.bookings?.charges?.every(
          (charge) => charge.clearedToGo === true,
        )) &&
      !finalPayload?.bookings?.releaseQueueDetails?.some(
        (item) => item.releaseQueStepID === 155400001,
      )
    ) {
      finalPayload.bookings.releaseQueueDetails = [
        ...(finalPayload?.bookings?.releaseQueueDetails || []),
        {
          releaseQueStepID: 155400001, // For charges cleared
          complete: true,
          completionDate: dayjs().format("MM/DD/YYYY"),
          completionTime: dayjs().format("HH:mm"),
          completionStaffID: userDetails?.staffId,
        },
      ];
    }

    if (
      ((finalPayload?.bookings?.inmateTracking?.length &&
        !finalPayload?.bookings?.inmateTracking?.some(
          (item) => item.movementStatus === "Complete",
        )) ||
        !finalPayload?.bookings?.inmateTracking?.length) &&
      !isScheduledBooking
    ) {
      showDialog("info", {
        title: "Warning",
        content:
          "You must have atleast one complete move status in house & track",
        onConfirm: () => {
          tabChangeRef.current?.setSelectedGroup("arrest-report");
          setTimeout(() => {
            tabChangeRef.current?.onTabChange("housing-tracking");
          }, 0);
        },
      });
      return;
    }

    setIsLoading(() => true);
    if (deleteAPis?.length) {
      try {
        deleteAPis?.forEach((d) => {
          if (bookings?.bookingId)
            d = d + `?rootAppContextKeyFieldId=${bookings.bookingId}`;
          api.delete(d);
        });
      } catch (error) {
        notificationService.error("Error", "Error Deleting Booking Items");
        setIsLoading(() => false);
        return;
      }
    }
    let bkng = finalPayload?.bookings;
    if (bkng) {
      let arr_rep = bkng?.arrestReports;
      let inmt_mvnt = bkng?.inmateTracking;
      if (arr_rep && inmt_mvnt) {
        if (inmt_mvnt?.length) {
          let last_arr = inmt_mvnt.length - 1;
          let { bed, block, cell } = inmt_mvnt[last_arr];
          arr_rep[0].housingAssignmentBed = bed;
          arr_rep[0].housingAssignmentCell = cell;
          arr_rep[0].housingAssignmentBlock = block;
        }
      }
    }

    api
      .post(API_ENDPOINTS.bookingsCreate, finalPayload)
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          if (!isNonEmptyVariable(payload?.bookingId)) {
            dispatch(
              setBookings({
                bookingNumber: res?.data?.bookingNumber,
                bookingId: res?.data?.bookingId,
              }),
            );
            dispatch(
              setLastBookingsFromAPI({
                bookingNumber: res?.data?.bookingNumber,
                bookingId: res?.data?.bookingId,
              }),
            );
            sessionStorage.setItem("createNewBooking", false);
            notificationService.success(
              "Success",
              "New Bookings created successfully",
            );
          } else {
            dispatch(
              setBookings({
                ...payload,
              }),
            );
            dispatch(setLastBookingsFromAPI(payload));
            notificationService.success(
              "Success",
              "Booking updated successfully",
            );
          }
          if (res?.data?.bookingNumber) onSearch(res?.data?.bookingNumber);
          if (isBQ) {
            // getLatestBookings();
            bqCompleteSaveAction();
          }
          setSaveVisible(false);
          setSearchTxt("");
          setIsLoading(() => false);
          dispatch(setBookingsFieldsEnabled(false));
          if (
            !isScheduledBooking ||
            (isScheduledBooking &&
              bookings?.arrestReports?.[0]?.scheduledBookingCleared === true)
          ) {
            dispatch(setIsScheduledBooking(false));
          }

          setisLoadingHT(() => false);
          setTimeout(() => {
            setisShowTracking(() => false);
          }, 0);

          dispatch(setIrisSearchId(0));
          dispatch(setIrisEnrolleId(0));
        } else {
          notificationService.error("Failed!", "New Bookings created failed!");
        }
      })
      .catch((err) => {
        notificationService.error("Failed!", "New Bookings created failed");
      })
      .finally(() => {
        dispatch(setDeleteAPIEmpty());
        setIsLoading(() => false);
      });
  };

  const handleReleaseInmate = async (activeSubModules) => {
    const payload = _.cloneDeep(bookings);

    const scheduledReleaseDate =
      payload?.arrestReports?.[0]?.scheduledReleaseDate;
    const scheduledReleaseTime =
      payload?.arrestReports?.[0]?.scheduledReleaseTime;
    const currentDateTime = dayjs();
    let charges = payload?.charges;
    let releaseDateTimeCharges;
    let releaseDate;
    let releaseTime;
    if (isNonEmptyVariable(charges)) {
      let controllingCharge = charges.find((e) => e.controllingCharge == true);
      if (isNonEmptyVariable(controllingCharge)) {
        releaseDate = controllingCharge?.scheduledReleaseDate;
        releaseTime = controllingCharge?.scheduledReleaseTime;
        if (isNonEmptyVariable(releaseDate) && isNonEmptyVariable(releaseTime))
          releaseDateTimeCharges = new Date(`${releaseDate} ${releaseTime}`);
      }
    }
    if (scheduledReleaseDate && scheduledReleaseTime) {
      const scheduledDateTime = dayjs(
        `${scheduledReleaseDate} ${scheduledReleaseTime}`,
      );

      if (scheduledDateTime.isAfter(currentDateTime)) {
        const data = await getRestrictForRelease(
          `Inmate is not scheduled to be released until that date ${bookings?.arrestReports?.[0]?.scheduledReleaseDate} at ${bookings?.arrestReports?.[0]?.scheduledReleaseTime}. Do wish to continue inmate release?`,
        );
        if (!data) {
          return;
        }
      }
    }
    if (releaseDateTimeCharges) {
      if (releaseDateTimeCharges.getTime() > Date.now()) {
        const data = await getRestrictForRelease(
          `Inmate is not scheduled to be released until that date ${releaseDate} at ${releaseTime}. Do wish to continue inmate release?`,
        );
        if (!data) {
          return;
        }
      }
    }
    Promise.all([
      allFormRef?.personalFormRef?.current?.validateFields(),
      allFormRef?.personalFormAliasesRef?.current?.validateFields(),
      allFormRef?.personalFormPlaceOfBirthRef?.current?.validateFields(),
      // allFormRef?.personalFormDistinguishingRef?.current?.validateFields(),
      allFormRef?.arrestbookFormRef?.current?.validateFields(),
      allFormRef?.inmateInfoRef?.current?.validateFields(),
      allFormRef?.propertyRef?.current?.validateFields(),
      allFormRef?.scheduledBookingRef?.current?.validateFields(),
    ])
      .then(() => {
        if (!bookings?.charges?.length) {
          notificationService.error("Validation Error", `Please add Charges`);
          tabChangeRef.current?.setSelectedGroup("arrest-report");
          setTimeout(() => {
            tabChangeRef.current?.onTabChange("charges");
          }, 0);
          return;
        }
        releaseInmate(activeSubModules);
      })
      .catch((err) => {
        let tabToChange = "personal-information";

        let requiredField = err?.errorFields[0]?.name[0];

        if (requiredField) {
          tabToChange =
            Object.keys(mandatoryFields).find((tab) =>
              mandatoryFields[tab].includes(requiredField),
            ) || "personal-information";
        }

        notificationService.error(
          "Validation Error",
          `Fill all mandatory fields in ${tabToChange
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")}`,
        );

        if (tabToChange === "property-taken-inmate") {
          tabChangeRef.current?.setSelectedGroup("inmate-property");
        } else {
          tabChangeRef.current?.setSelectedGroup("arrest-report");
        }

        setTimeout(() => {
          tabChangeRef.current?.onTabChange(tabToChange);
          // Move focus to the first error element
          setTimeout(() => {
            const firstErrorField = document.querySelector(`#${requiredField}`);
            firstErrorField?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            firstErrorField?.focus();
          }, 300);
        }, 0);
      });
  };

  const buildPendingMovementMessage = (m) => {
    const scheduled =
      m?.scheduledDate && m?.scheduledTime
        ? `${m.scheduledDate} ${m.scheduledTime}`
        : "N/A";

    const expectedBack =
      m?.expectedBackDate && m?.expectedBackTime
        ? `${m.expectedBackDate} ${m.expectedBackTime}`
        : "N/A";
    
    const loanLoc = m?.inmateLocation;

    const loanTo =
      m?.loanType
        ? `${m.loanType}${m.loanDestination ? ` (${m.loanDestination})` : ""}`
        : m?.inmateLocation || "N/A";
    
    const approvedBy =
      m?.approvingOfficerStaffID
        ? getRefListNameByID("", m.approvingOfficerStaffID, true)
        : " ";
    
    const transportBy =
      m?.transportingOfficerStaffID
        ? getRefListNameByID("", m.transportingOfficerStaffID, true)
        : " ";
    
    let transprt = "";
    if(transportBy) {
      transprt = `Transport by ${transportBy}.`;
    }

    let approved = "";
    if(approvedBy) {
      approved = `Approved by ${approvedBy}.`;
    }

    return `
    This inmate has a pending movement scheduled for ${scheduled}.

    ${loanLoc} to ${loanTo}
    at ${scheduled}. ${transprt} Reason: ${m?.moveReason || "N/A"}. ${approved}
    Expected back at ${expectedBack}.

    Do you want to cancel it?
    `.trim();
  };

  const releaseInmate = async (activeSubModules) => {
    const payload = _.cloneDeep(bookings);
    delete payload?.genericInterfaceSubmission;
    delete payload?.medicalQuestionnaires;
    delete payload?.visitorLogBooking;

    const ch = payload?.charges?.find(
      (c) => c?.controllingCharge && c?.clearedToGo,
    );

    const bookingDateTime = getDayjsObject(
      payload?.arrestReports?.[0]?.incarcerationDate,
      payload?.arrestReports?.[0]?.incarcerationTime,
    );
    const releaseDateTime = getDayjsObject(
      ch?.clearanceDate,
      ch?.clearanceTime,
    );

    dispatch(
      setBookings({
        arrestReports: [
          {
            ...bookings?.arrestReports?.[0],
            releaseDate: ch?.clearanceDate || null,
            releaseTime: ch?.clearanceTime || null,
            releaseReasonId: ch?.clearanceReasonID || null,
            releaseOfficerStaffId: userDetails?.staffId || null,
            totalDaysInCustody:
              bookings?.detentions?.length &&
              isNonEmptyVariable(
                bookings?.detentions?.[bookings?.detentions?.length - 1]
                  ?.lengthOfStay,
              )
                ? bookings?.detentions?.[bookings?.detentions?.length - 1]
                    ?.lengthOfStay
                : releaseDateTime?.diff(bookingDateTime, "day") != 0
                  ? releaseDateTime?.diff(bookingDateTime, "day")
                  : 1,
          },
        ],
      }),
    );

    const agency = user?.staff?.organization?.[0]?.agency;
    const preFinalPayload = cleanObject(payload);
    const finalPayload = {
      bookings: {
        ...preFinalPayload,
        creatorStaffId: userDetails?.staffId,
        inJail: false,
        user: userDetails?.username,
        jackets: [
          {
            ...((preFinalPayload?.jackets && preFinalPayload.jackets[0]) || {}),
            jacketId: bookings?.["Folder ID"] || bookings?.jacketId || null,
            staffJacket: false,
            orphanFlag: false,
          },
        ],
        arrestReports: [
          {
            ...((preFinalPayload?.arrestReports &&
              preFinalPayload.arrestReports[0]) ||
              {}),
            housingAgency: agency,
            custodialAgency: agency,
            releaseDate: ch?.clearanceDate || null,
            releaseTime: ch?.clearanceTime || null,
            releaseReasonId: ch?.clearanceReasonID || null,
            releaseOfficerStaffId: userDetails?.staffId || null,
            totalDaysInCustody:
              preFinalPayload?.detentions?.length &&
              isNonEmptyVariable(
                preFinalPayload?.detentions?.[
                  preFinalPayload?.detentions?.length - 1
                ]?.lengthOfStay,
              )
                ? preFinalPayload?.detentions?.[
                    preFinalPayload?.detentions?.length - 1
                  ]?.lengthOfStay
                : releaseDateTime?.diff(bookingDateTime, "day") != 0
                  ? releaseDateTime?.diff(bookingDateTime, "day")
                  : 1,
          },
        ],
        bio: [
          {
            ...((preFinalPayload?.bio && preFinalPayload.bio[0]) || {}),
            bioPhotos:
              preFinalPayload?.bio[0]?.bioPhotos?.map((p) => {
                return {
                  ...p,
                  lineupFlag: true,
                };
              }) || [],
          },
        ],
      },
    };

    const currentDateTime = dayjs().format("MM/DD/YYYY HH:mm");
    finalPayload.bookings.arrestReports[0].releaseDate =
      currentDateTime.split(" ")[0];
    finalPayload.bookings.arrestReports[0].releaseTime =
      currentDateTime.split(" ")[1];
    // finalPayload.bookings.arrestReports[0].incarcerationDate =
    //   currentDateTime.split(" ")[0];
    // finalPayload.bookings.arrestReports[0].incarcerationTime =
    //   currentDateTime.split(" ")[1];
    finalPayload.bookings.arrestReports[0].releaseReasonId ??= 54240020;
    finalPayload.bookings.arrestReports[0].holdReasonId ??= 154530006;

    finalPayload.bookings.inmateTracking.push({
      inmateTrackingID: null,
      inmateLocation: "RELEASED",
      movementStatus: "Complete",
    });
    let isArrestReport = activeSubModules?.find((act) => {
      return act.value == "arrest-report";
    });

    if (
      finalPayload?.bookings?.charges?.length &&
      finalPayload?.bookings?.charges?.some(
        (c) => c?.clearedToGo === false || !isNonEmptyVariable(c?.clearedToGo),
      )
    ) {
      if (!isArrestReport) {
        showDialog("info", {
          title: "Warning",
          content:
            "Arrest Report is disabled, enable it in config and try again.",
          confirmButtonText: "Ok",
        });
        return;
      }
      showDialog("info", {
        title: "Warning",
        content:
          "According to the arrest charges, the inmate is not yet cleared to go. You must clear all of the charges before the inmate can be released.",
        confirmButtonText: "Ok",
      });

      if (isArrestReport) {
        tabChangeRef.current?.setSelectedGroup("arrest-report");
      }

      setTimeout(() => {
        tabChangeRef.current?.onTabChange("charges");
      }, 0);

      return;
    }

    if (
      finalPayload?.bookings?.holds?.length &&
      finalPayload?.bookings?.holds?.some((c) => c?.holdStatus === "52180003")
    ) {
      if (!isArrestReport) {
        showDialog("info", {
          title: "Warning",
          content:
            "Arrest Report is disabled, enable it in config and try again.",
          confirmButtonText: "Ok",
        });
        return;
      }
      showDialog("info", {
        title: "Warning",
        content:
          "Inmate has holds and cannot be released. If you are trying to release the inmate to an agency that has a hold on them, edit the details of that Hold and change the Status to 'Hold for Transfer'.",
        confirmButtonText: "Ok",
      });
      if (isArrestReport) {
        tabChangeRef.current?.setSelectedGroup("arrest-report");
      }

      setTimeout(() => {
        tabChangeRef.current?.onTabChange("holds");
      }, 0);

      return;
    }

    if (
      finalPayload?.bookings?.inmateProperty?.length &&
      finalPayload?.bookings?.inmateProperty?.some(
        (c) =>
          c?.propertyReleased === false ||
          !isNonEmptyVariable(c?.propertyReleased),
      )
    ) {
      const data = await getRestrictForRelease(
        "The Inmate still has property that has not been released. Do you wish to continue inmate release?",
      );

      if (!data) {
        return;
      }
    }

    if (
      finalPayload?.bookings?.inmateTracking?.length &&
      finalPayload?.bookings?.inmateTracking?.some(
        c =>
          c?.movementStatus === "Pending" ||
          !isNonEmptyVariable(c?.movementStatus),
      )
    ) {
      const pendingMovements =
        finalPayload.bookings.inmateTracking
          .filter(
            c =>
              c?.movementStatus === "Pending" ||
              !isNonEmptyVariable(c?.movementStatus)
          )
          .sort((a, b) => b.inmateTrackingID - a.inmateTrackingID);

      if (!pendingMovements.length) {
        return;
      }

      for (const movement of pendingMovements) {
        const message = buildPendingMovementMessage(movement);
        const confirmed = await getRestrictForRelease(message);
        if (!confirmed) {
          return;
        }
        movement.movementStatus = "Cancelled";
      }
    }

    if (
      finalPayload?.bookings?.bookingBails?.length &&
      finalPayload?.bookings?.bookingBails?.reduce((sum, bb) => {
        if (!isNonEmptyVariable(bb?.paid) || !bb?.paid) {
          return (sum += bb?.bailAmount);
        } else {
          return sum;
        }
      }, 0) > 0
    ) {
      showDialog("info", {
        title: "Warning",
        content: "There are bails that are unpaid",
        confirmButtonText: "Ok",
      });
      tabChangeRef.current?.setSelectedGroup("arrest-report");
      setTimeout(() => {
        tabChangeRef.current?.onTabChange("charges");
      }, 0);
      return;
    }

    if (finalPayload?.bookings?.victimNotifications?.length) {
      const data = await getRestrictForRelease(
        "Victims exist that have not been notified. Do you wish to continue inmate release?",
      );

      if (!data) {
        return;
      }
    }

    if (
      finalPayload?.bookings?.holds?.length &&
      finalPayload?.bookings?.holds?.some(
        (c) =>
          c?.holdStatus === "Cleared" || !isNonEmptyVariable(c?.holdStatus),
      )
    ) {
      const data = await getRestrictForRelease(
        "Inmate has holds and cannot be released. If you are trying to release the inmate to an agency that has a hold on them, edit the details of that Hold and change the Status to 'Hold for Transfer'.",
      );

      if (!data) {
        return;
      }
    }

    if (
      finalPayload?.bookings?.holds?.length &&
      finalPayload?.bookings?.holds?.some(
        (c) =>
          c?.holdStatus === "Hold for Transfer" ||
          !isNonEmptyVariable(c?.holdStatus),
      )
    ) {
      const data = await getRestrictForRelease(
        "Inmate must be released to ANOTHER CASE. Do you wish to continue inmate release?",
      );

      if (!data) {
        return;
      }
    }

    if (
      finalPayload?.bookings?.releaseNotes?.length &&
      finalPayload?.bookings?.releaseNotes?.some(
        (c) => !c?.cleared || isNonEmptyVariable(c?.holdStatus),
      )
    ) {
      const firstNote = finalPayload?.bookings?.releaseNotes?.[0]?.releaseNote ?? "";
      const firstCmt = finalPayload?.bookings?.releaseNotes?.[0]?.comments ?? "";

      let dispNote = "";
      if(firstNote && firstCmt) {
        dispNote = `RELEASE NOTE: ${firstNote}, ${firstCmt}.`;
      }
      else if(firstNote && !firstCmt) {
        dispNote = `RELEASE NOTE: ${firstNote}.`;
      }

      const data = await getRestrictForRelease(
        `${dispNote} Do you wish to continue inmate release?`
      );

      if (!data) {
        return;
      }
    }

    finalPayload.bookings.readyForRelease = false;
    finalPayload.bookings.isNeedToSubmitGenericInterface = true;

    setIsLoading(() => true);
    api
      .post(API_ENDPOINTS.bookingsCreate, finalPayload)
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          if (!isNonEmptyVariable(payload?.bookingId)) {
            dispatch(
              setBookings({
                bookingNumber: res?.data?.bookingNumber,
                bookingId: res?.data?.bookingId,
              }),
            );
            notificationService.success(
              "Success",
              "Inmate release successfully",
            );

            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange("release-information");
            }, 0);
          } else {
            dispatch(
              setBookings({
                ...payload,
              }),
            );
            notificationService.success(
              "Success",
              "Inmate release successfully",
            );
            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange("release-information");
            }, 0);
          }
          onSearch(payload?.bookingNumber);
          // getLatestBookings();
          if (isBQ) {
            bqCompleteSaveAction();
          }
        } else {
          notificationService.error("Failed!", "Inmate release failed!");
        }
      })
      .catch((err) => {
        notificationService.error("Failed!", "Inmate release failed");
      })
      .finally(() => {
        dispatch(setDeleteAPIEmpty());
        setIsLoading(() => false);
        cancelBookingsAction();
      });
  };

  const takeProperty = async () => {
    if (
      bookings?.inmateProperty?.[0]?.inmatePropertyItems?.length <= 0 ||
      !bookings?.inmateProperty?.[0]?.inmatePropertyItems
    ) {
      tabChangeRef.current?.onTabChange("property-taken-inmate");
    } else {
      tabChangeRef.current?.onTabChange("property-list");
    }
  };

  const releaseAllProperty = async () => {
    tabChangeRef.current?.onTabChange("property-taken-inmate");
    // Clone the current bookings payload and clean unwanted properties.
    const payload = _.cloneDeep(bookings);
    delete payload?.genericInterfaceSubmission;
    delete payload?.medicalQuestionnaires;
    delete payload?.visitorLogBooking;
    // If inmateProperty exists, update its items.
    if (
      payload &&
      payload.inmateProperty &&
      payload.inmateProperty.length > 0
    ) {
      const inmateProp = payload.inmateProperty[0];

      if (
        inmateProp.inmatePropertyItems &&
        inmateProp.inmatePropertyItems.length > 0 &&
        inmateProp.inmatePropertyItems[0].inventoryItems &&
        inmateProp.inmatePropertyItems[0].inventoryItems[0]
      ) {
        // 1. Extract storage locations from the first item's inventory
        const firstNonDisposedProperty = [
          ...inmateProp.inmatePropertyItems,
        ].find(
          (property) =>
            property?.inventoryItems?.[0]?.itemStatus !== "Disposed",
        );
        const loc1 =
          firstNonDisposedProperty?.inventoryItems?.[0]?.storageLocation1Id;
        const loc2 =
          firstNonDisposedProperty?.inventoryItems?.[0]?.storageLocation2Id;
        const loc3 =
          firstNonDisposedProperty?.inventoryItems?.[0]?.storageLocation3Id;

        // 2. Look up labels using your options arrays
        const storageLocation1Options = getOptionsFromRefList(
          "Storage_Location_1",
          false,
          false,
          true,
        );
        const storageLocation2Options = getOptionsFromRefList(
          "Inmate_Property_Storage_Location_1",
          false,
          false,
          true,
        );
        const storageLocation3Options = getOptionsFromRefList(
          "Inmate_Property_Storage_Location_2",
          false,
          false,
          true,
        );
        const loc1Name =
          storageLocation1Options.find((opt) => opt.value === loc1)?.label ||
          "";
        const loc2Name =
          storageLocation2Options.find((opt) => opt.value === loc2)?.label ||
          "";
        const loc3Name =
          storageLocation3Options.find((opt) => opt.value === loc3)?.label ||
          "";

        // 3. Build the property comments string
        const propertyComments = `PROPERTY LOCATION - ${loc1Name} ${loc2Name} ${loc3Name}`;
        // 4. Update each inmate property item: clear storage locations and set itemStatus to "Disposed"
        inmateProp.inmatePropertyItems = inmateProp.inmatePropertyItems.map(
          (item) => {
            if (item.inventoryItems && item.inventoryItems[0]) {
              item.inventoryItems[0].storageLocation1Id = "";
              item.inventoryItems[0].storageLocation2Id = "";
              item.inventoryItems[0].storageLocation3Id = "";
              item.inventoryItems[0].itemStatus = "Disposed";
              item.inventoryItems[0].disposalType = "Return to Owner";
            }
            return item;
          },
        );

        // 5. Update the outer inmate property with the new propertyComments.
        inmateProp.propertyComments = propertyComments;
        inmateProp.propertyReleased = true;
      }
    }

    const agency = user?.staff?.organization?.[0]?.agency;

    // Clean up the payload further if needed.
    const preFinalPayload = cleanObject(payload);

    // Construct finalPayload with additional fields.
    const finalPayload = {
      bookings: {
        ...preFinalPayload,
        creatorStaffId: userDetails?.staffId,
        user: userDetails?.username,
        jackets: [
          {
            ...((preFinalPayload?.jackets && preFinalPayload.jackets[0]) || {}),
            staffJacket: false,
            orphanFlag: false,
          },
        ],
        arrestReports: [
          {
            ...((preFinalPayload?.arrestReports &&
              preFinalPayload.arrestReports[0]) ||
              {}),
            housingAgency: agency,
            custodialAgency: agency,
          },
        ],
        bio: [
          {
            ...((preFinalPayload?.bio && preFinalPayload.bio[0]) || {}),
            bioPhotos:
              preFinalPayload?.bio[0]?.bioPhotos?.map((p) => {
                return {
                  ...p,
                  lineupFlag: true,
                };
              }) || [],
          },
        ],
      },
    };

    setIsLoading(() => true);
    api
      .post(API_ENDPOINTS.bookingsCreate, finalPayload)
      .then((res) => {
        if (res?.data?.statusCode === 200) {
          if (!isNonEmptyVariable(payload?.bookingId)) {
            dispatch(
              setBookings({
                bookingNumber: res?.data?.bookingNumber,
                bookingId: res?.data?.bookingId,
              }),
            );
            notificationService.success(
              "Success",
              "Inmate property released successfully",
            );
          } else {
            dispatch(setBookings({ ...payload }));
            notificationService.success(
              "Success",
              "Inmate property released successfully",
            );
          }
          if (searchTxt === "" || isBQ) {
            // getLatestBookings();
          }
          if (isBQ) {
            bqCompleteSaveAction();
          }
        } else {
          notificationService.error(
            "Failed!",
            "Inmate property release failed!",
          );
        }
      })
      .catch((err) => {
        notificationService.error("Failed!", "Inmate property release failed");
      })
      .finally(() => {
        setIsLoading(() => false);
        dispatch(setDeleteAPIEmpty());
      });
  };

  const getRestrictForRelease = (content) => {
    return new Promise((resolve, reject) => {
      showDialog("confirm", {
        title: "Warning",
        content: content,
        onConfirm: () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        },
      });
    });
  };

  const onSearch = (value) => {
    setIsLoading(() => false);
    if (value === "") {
      setSearchTxt("");
      return;
    }
    if (isNaN(value)) {
      notificationService.error("Please enter a valid Booking Number");
      return;
    } else {
      dispatch(setBookingsNull());
      setSearchTxt(value);
      setIsLoading(true);
      api
        .get(API_ENDPOINTS.getBookingByID + value)
        .then((response) => {
          if (response.status === 200 && response.data) {
            dispatch(setBookings(response?.data));
            dispatch(setLastBookingsFromAPI(response?.data));
          } else {
            notificationService.error("No record found");
          }
        })
        .catch((error) => {
          notificationService.error("No record found");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handleScheduledBooking = () => {
    newBookingsAction(null, true);
  };

  const handleSelectBookingNumber = (value) => {
    dispatch(setBookingsNull());
    dispatch(setLastBookingsFromAPI(null));
    setReportListLoading(true);
    api
      .get(API_ENDPOINTS.getBookingByID + value)
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(setBookings(response?.data));
          dispatch(setLastBookingsFromAPI(response?.data));
          dispatch(setShowBookings(true));
        } else {
          notificationService.error("No record found");
        }
      })
      .finally(() => {
        setReportListLoading(false);
      });
  };

  const getReportListData = async () => {
    try {
      setReportListLoading(true);
      setReportListData([]);
      setFilteredReportListData([]);

      let url = `${API_ENDPOINTS.bookingsSearch}?direction=ASC`;

      const obj = {
        page: tablePagination.pageIndex,
        size: tablePagination.pageSize,
      };

      const urlParam = toQueryString(obj);

      if (isNonEmptyVariable(urlParam)) {
        url += "&" + urlParam;
      }

      let payload = bookingSearchPayload;

      if (!isFiltered) {
        payload = [
          ...bookingSearchPayload,
          { filterKey: "isBookingList", value: true },
        ];
      }

      const result = await api.post(url, payload);

      // const injailList = result?.data?.rows?.filter(
      //   (r) => r?.currentLocation === "In Jail"
      // );
      if (!isFiltered) {
        setReportListTotal(result?.data?.total);
      }
      setReportListData(() => result?.data?.rows);
      setFilteredReportListData(() => result?.data?.rows);
    } catch (err) {
      setReportListData([]);
      setFilteredReportListData([]);
    } finally {
      setReportListLoading(false);
    }
  };

  const handleChangePagination = (pageIndex, pageSize) => {
    setTablePagination({
      pageIndex,
      pageSize,
    });
  };

  // const handleBackToList = () => {
  //   setBookingSearchPayload([
  //     { filterKey: "searchType", value: "Starts With" },
  //     // { filterKey: "custodyStatus", value: "In Custody" },
  //   ]);
  //   setPagination({
  //     pageIndex: 0,
  //     pageSize: 100,
  //   });
  //   setTablePagination({
  //     pageIndex: 0,
  //     pageSize: 100,
  //   });
  //   setIsFiltered(false);
  //   dispatch(setShowBookings(false));
  //   dispatch(setBookingsNull());
  //   sessionStorage.setItem("createNewBooking", false);
  //   setSearchTxt("");
  //   dispatch(setIrisSearchId(0));
  //   dispatch(setIrisEnrolleId(0));
  //   dispatch(setIsScheduledBooking(false));
  //   dispatch(setFullSearch(false));
  // };

  const handleBackToList = () => {
    // Only switch view
    dispatch(setShowBookings(false));

    // Reset pagination but KEEP filters
    setPagination({
      pageIndex: 0,
      pageSize: 100,
    });

    setTablePagination({
      pageIndex: 0,
      pageSize: 100,
    });

    // Call API with existing filter payload
    dispatch(getBookings(bookingSearchPayload)); // 👈 your API action
  };

  const handleClearFilter = () => {
    const defaultPayload = [
      { filterKey: "searchType", value: "Starts With" },
    ];

    setBookingSearchPayload(defaultPayload);

    setPagination({
      pageIndex: 0,
      pageSize: 100,
    });

    setTablePagination({
      pageIndex: 0,
      pageSize: 100,
    });

    setIsFiltered(false);
    setSearchTxt("");

    dispatch(setShowBookings(false));
    dispatch(setBookingsNull());
    dispatch(setIrisSearchId(0));
    dispatch(setIrisEnrolleId(0));
    dispatch(setIsScheduledBooking(false));
    dispatch(setFullSearch(false));

    // Call API with default payload
    dispatch(getBookings(defaultPayload));
  };

  const handleClear = () => {
    setBookingSearchPayload([
      { filterKey: "searchType", value: "Starts With" },
      // { filterKey: "custodyStatus", value: "In Custody" },
    ]);
    setPagination({
      pageIndex: 0,
      pageSize: 100,
    });
    setTablePagination({
      pageIndex: 0,
      pageSize: 100,
    });
    setIsFiltered(false);
    setSearchTxt("");
  };

  const handleCancel = () => {
    setShowFilter(false);
  };

  const handleFilter = () => {
    setShowFilter(true);
  };

  const onDelete = async () => {
    if (!bookings.bookingId) {
      const data = await getLatestBookingsUtil();
      dispatch(setLastBookingsFromAPI(data));
      dispatch(
        setBookings({
          ...data,
        }),
      );

      return;
    }

    const content = `You are deleting Bookings ${bookings?.bookingNumber}. Are you sure you want to delete all information for this record?`;
    const canDelete = await new Promise((resolve, reject) => {
      showDialog("confirm", {
        title: "Warning",
        content: content,
        onConfirm: () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        },
      });
    });

    if (!canDelete) {
      return;
    }

    setIsDeleting(true);
    api
      .delete(API_ENDPOINTS.bookingsByBookingId + bookings.bookingId)
      .then(async (response) => {
        setIsDeleting(false);
        dispatch(setBookingsNull());
        dispatch(setLastBookingsFromAPI([]));

        notificationService.success(
          "Success!",
          "Booking data deleted successfully",
        );

        notificationService.info("Fetching latest data. Please wait...");

        const data = await getLatestBookingsUtil();
        dispatch(setLastBookingsFromAPI(data));
        dispatch(
          setBookings({
            ...data,
          }),
        );
      })
      .finally(() => {
        setIsDeleting(false);
        dispatch(setIrisSearchId(0));
        dispatch(setIrisEnrolleId(0));
      });
  };

  useEffect(() => {
    console.log("selectedGroupVal : ", selectedGroup);
  }, [selectedGroup]);

  const isAddDisabled = reportListLoading ||
                      !hasCheckSecurity(
                        Security_Types.functionality,
                        Entity_types.module,
                        LABELS_CAPITAL.ADD,
                        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                      ) ||
                      (!hasCheckSecurity(
                        Security_Types.functionality,
                        Entity_types.subModule,
                        LABELS_CAPITAL.ADD,
                        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                        SUB_MODULES_LIST_WITH_ID.Arrest_Report,
                      ) &&
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.subModule,
                          LABELS_CAPITAL.ADD,
                          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                          SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
                        ) &&
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.subModule,
                          LABELS_CAPITAL.ADD,
                          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                          SUB_MODULES_LIST_WITH_ID.Inmate_Property,
                        ) &&
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.subModule,
                          LABELS_CAPITAL.ADD,
                          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                          SUB_MODULES_LIST_WITH_ID.Inmate_Officer_Reports,
                        ));

  const subModuleMap = {
    "arrest-report": SUB_MODULES_LIST_WITH_ID.Arrest_Report,
    "inmate-medical": SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
    "inmate-property": SUB_MODULES_LIST_WITH_ID.Inmate_Property,
    "inmate-inmate-officer-reports": SUB_MODULES_LIST_WITH_ID.Inmate_Officer_Reports,
  };

  // Modify Access Check
  const hasBookingModifyAccess = hasCheckSecurity(
    Security_Types.functionality,
    Entity_types.module,
    LABELS_CAPITAL.MODIFY,
    MODULES_LIST_WITH_ID.MODULE_BOOKINGS
  );

  const hasSelectedSubModuleModifyAccess = selectedGroup
    ? hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.MODIFY,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        subModuleMap[selectedGroup]
      )
    : false;

  const isModifyDisabled = !hasBookingModifyAccess || !hasSelectedSubModuleModifyAccess;

  // DELETE Access Check
  const hasBookingDeleteAccess = hasCheckSecurity(
    Security_Types.functionality,
    Entity_types.module,
    LABELS_CAPITAL.DELETE,
    MODULES_LIST_WITH_ID.MODULE_BOOKINGS
  );

  const hasSelectedSubModuleDeleteAccess = selectedGroup
    ? hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.DELETE,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        subModuleMap[selectedGroup]
      )
    : false;

  const isDeleteDisabled = !hasBookingDeleteAccess || !hasSelectedSubModuleDeleteAccess;

  return (
    <StyledBookingsContainer data-lenis-prevent headerHeight={headerHeight}>
      <StyledGridRow justify="space-between">
        <StyledGridCol span={24}>
          <StyledDarkSectionTitle bgColor="rgb(4 28 45)">
            <span>Bookings</span>
          </StyledDarkSectionTitle>
        </StyledGridCol>
      </StyledGridRow>

      {!fromFolderDetails && (
        <>
          {saveVisible || fullSearch ? (
            <StyledActionControlContainer>
              <Button
                color="warning"
                variant="solid"
                onClick={fullSearch ? fullSearchAction : preSaveBookingAction}
                disabled={isLoading || isModifyDisabled}
              >
                {fullSearch ? "Search" : "Save Changes"}
              </Button>

              {!isBQ && (
                <Button
                  color="primary"
                  type="primary"
                  variant="solid"
                  onClick={fullSearch ? handleBackToList : cancelBookingsAction}
                  disabled={isLoading}
                >
                  Cancel
                </Button>
              )}
            </StyledActionControlContainer>
          ) : (
            <ActionHeader>
              <Flex gap={10}>
                {showBookings && (
                    <Button
                      color="primary"
                      variant="solid"
                      onClick={modifyBookingsAction}
                      disabled={isModifyDisabled}
                    >
                      Modify
                    </Button>
                )}
                <DropdownButton
                  items={DropdownButtonItem}
                  buttonText={"Create New"}
                  handleItemClicked={handleScheduledBooking}
                  onButtonClick={newBookingsAction}
                  disabled={isAddDisabled}
                />
                {showBookings && (
                  <Button
                    color="primary"
                    variant="solid"
                    onClick={onDelete}
                    loading={isDeleting}
                    disabled={isDeleteDisabled}
                  >
                    Expunge
                  </Button>
                )}
                {(showBookings || isFiltered) && (
                  <Button
                    color="primary"
                    type="primary"
                    variant="solid"
                    onClick={handleBackToList}
                    disabled={
                      !hasCheckSecurity(
                        Security_Types.functionality,
                        Entity_types.module,
                        LABELS_CAPITAL.VIEW,
                        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                      )
                    }
                  >
                    {isFiltered && !showBookings ? "Clear Filter" : "Back to List"}
                  </Button>
                ) && false}
                {(showBookings || isFiltered) && (
                  <>
                    {isFiltered && !showBookings ? (
                      <Button
                        color="primary"
                        type="primary"
                        variant="solid"
                        onClick={handleClearFilter}
                      >
                        Clear Filter
                      </Button>
                    ) : (
                      <Button
                        color="primary"
                        type="primary"
                        variant="solid"
                        onClick={handleBackToList}
                      >
                        Back to List
                      </Button>
                    )}
                  </>
                )}
              </Flex>
              <>
                {showBookings && (
                  <Search
                    style={{ width: 300 }}
                    placeholder={"Search by Booking Number"}
                    allowClear
                    enterButton="Search"
                    // size="large"
                    onSearch={(e) => onSearch(e)}
                    disabled={
                      !hasCheckSecurity(
                        Security_Types.functionality,
                        Entity_types.module,
                        LABELS_CAPITAL.FIND,
                        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                      )
                    }
                  />
                )}

                {!showBookings &&
                  hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.module,
                    LABELS_CAPITAL.VIEW,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  ) && (
                    <Button
                      color="primary"
                      type="primary"
                      variant="solid"
                      onClick={handleFilter}
                      disabled={
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.module,
                          LABELS_CAPITAL.FIND,
                          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                        )
                      }
                    >
                      Show Filter
                    </Button>
                  )}
              </>
            </ActionHeader>
          )}
        </>
      )}
      {!userDetailLoading && (
        <>
          {hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.module,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          ) ? (
            <>
              {!showBookings && (
                <ReportList
                  results={filteredReportListData}
                  selectBookingNumber={handleSelectBookingNumber}
                  isLoading={reportListLoading}
                  pagination={pagination}
                  setPagination={setPagination}
                  total={reportListTotal}
                  handleChangePagination={handleChangePagination}
                  setSaveVisible={setSaveVisible}
                  handleClear={handleClear}
                  getReportListData={getReportListData}
                />
              )}
            </>
          ) : (
            <>{!reportListLoading && <NoAccess moduleName={"bookings"} />}</>
          )}
        </>
      )}

      {showFilter && (
        <BookingsFilter
          isFindModalVisible={showFilter}
          setIsFindModalVisible={setShowFilter}
          onHandleCancel={handleCancel}
          setReportListData={setFilteredReportListData}
          setReportListTotal={setReportListTotal}
          setBookingSearchPayload={setBookingSearchPayload}
          setPagination={setPagination}
          setIsFiltered={setIsFiltered}
          apiModule={MODULES_LIST.BOOKINGS}
          path={MODULES_LIST.BOOKINGS}
          resetSignal={location.state?.resetFilters}
        />
      )}

      {showBookings && (
        <Spin spinning={isLoading} className="text-white" tip="Loading...">
          <InmateDetailsContainer accentBorder>
            <StyledBookingsContent>
              <BookingsDetails
                handleReBook={preRebook}
                currentModule={module || "arrest-report"}
                allFormRef={allFormRef}
                onNextClickTrigger={onNextClickTrigger}
                nextBtnRef={nextBtnRef}
                tabChangeRef={tabChangeRef}
                releaseInmate={handleReleaseInmate}
                takeProperty={takeProperty}
                releaseAllProperty={releaseAllProperty}
                fromBookingStep={fromBookingStep}
                fromFolderDetails={fromFolderDetails}
                selectedGroup={selectedGroup}
                setSelectedGroup={setSelectedGroup}
                currentTabKey={currentTabKey}
                setCurrentTabKey={setCurrentTabKey}
              />
            </StyledBookingsContent>
          </InmateDetailsContainer>
        </Spin>
      )}
      {isShowTracking && (
        <HouseAndTracksForm
          showDetailsPopup={isShowTracking}
          setShowDetailsPopup={setisShowTracking}
          isLoading={isLoadingHT}
          handleSave={handleSave}
          bookingsFieldsEnabled={true}
          // selectedRow={selectedRow}
          // mode={mode}
          houseFormRef={houseFormRef}
          // isEdit={isEdit}
          // setIsEdit={setIsEdit}
        />
      )}
    </StyledBookingsContainer>
  );
};

export default BookingsPage;
